import { ReactNode, useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';
import { User } from '@/types/user.types';
import { AuthContext } from './AuthContext';
import { identifyUser, resetPosthog, initPosthog } from '@/lib/analytics/posthog';
import { env } from '@/config/env';

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const { user, isAuthenticated, setAuth, clearAuth } = useAuthStore();

  useEffect(() => {
    const analyticsClient = initPosthog({
      enableAnalytics: env.enableAnalytics,
      posthogKey: env.posthogKey,
      posthogHost: env.posthogHost,
    });

    if (analyticsClient && user) {
      identifyUser(user, {
        app_env: env.appEnv,
      });
    }

    if (!user && !isAuthenticated) {
      resetPosthog();
    }
  }, [user, isAuthenticated]);

  const login = (user: User, accessToken: string, refreshToken: string) => {
    setAuth(user, accessToken, refreshToken);
    identifyUser(user, {
      app_env: env.appEnv,
      login_method: 'manual',
    });
  };

  const logout = () => {
    resetPosthog();
    clearAuth();
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
